// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import SingleTestimonial from "../../components/Testimonial";
// import SectionTitle from "../../components/SectionTitle";

// import shapeImg1 from "../../assets/img/testimonial/testi-shape-2.png";
// import shapeImg2 from "../../assets/img/testimonial/testi-shape-3.png";
// import shapeImg3 from "../../assets/img/testimonial/testi-shape-4.png";

// import testimonialImg1 from "../../assets/img/testimonial/testi-1.png";
// import testimonialImg2 from "../../assets/img/testimonial/testi-2.jpg";
// import testimonialImg3 from "../../assets/img/testimonial/testi-1.png";
// import testimonialImg4 from "../../assets/img/testimonial/testi-2.jpg";
// import { Pagination } from "swiper/modules";

// const Testimonial = () => {
//   const sliderOption = {
//     pagination: {
//       el: ".testimonial-slider-dots",
//       clickable: true,
//     },
//     loop: true,
//     spaceBetween: 30,
//     slidesPerView: "2",
//     breakpoints: {
//       0: {
//         slidesPerView: 1,
//       },
//       1200: {
//         slidesPerView: 2,
//       },
//     },
//   };

//   return (
//     <div className="testimonial__area testimonial__plr black-bg p-relative mb-100">
//       <div className="testimonial__shape-1">
//         <img src={shapeImg1} alt="" />
//       </div>
//       <div className="testimonial__shape-2">
//         <img src={shapeImg2} alt="" />
//       </div>
//       <div className="testimonial__shape-3">
//         <img src={shapeImg3} alt="" />
//       </div>
//       <div className="container-fluid">
//         <div className="row justify-content-center">
//           <div
//             className="col-xl-7 col-xxl-9 wow animate__fadeInUp"
//             data-wow-duration="1.1s"
//           >
//             <SectionTitle
//               sectionClass="testimonial__section-box text-center z-index pb-40 section-title-fixed-width"
//               subTitleClass="section-subtitle section-white-bg"
//               titleClass="section-title text-white"
//               subTitle="Client Testimonial"
//               Title="Perfect Contact This Software Company Manage."
//             />
//           </div>
//         </div>
//         <div
//           className="testimonial__slider-wrapper z-index wow animate__fadeInUp"
//           data-wow-duration="1.1s"
//         >
//           <div className="swiper-container testimonial__active">
//             <Swiper
//               modules={[Pagination]}
//               {...sliderOption}
//               className="swiper-wrapper"
//             >
//               <SwiperSlide className="swiper-slide">
//                 <SingleTestimonial authorImg={testimonialImg1} />
//               </SwiperSlide>
//               <SwiperSlide className="swiper-slide">
//                 <SingleTestimonial authorImg={testimonialImg2} />
//               </SwiperSlide>
//               <SwiperSlide className="swiper-slide">
//                 <SingleTestimonial authorImg={testimonialImg3} />
//               </SwiperSlide>
//               <SwiperSlide className="swiper-slide">
//                 <SingleTestimonial authorImg={testimonialImg4} />
//               </SwiperSlide>
//               <SwiperSlide className="swiper-slide">
//                 <SingleTestimonial authorImg={testimonialImg2} />
//               </SwiperSlide>
//             </Swiper>
//             <div className="testimonial-slider-dots wow animate__fadeInUp"></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Testimonial;
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SingleTestimonial from "../../components/Testimonial";
import SectionTitle from "../../components/SectionTitle";

import shapeImg1 from "../../assets/img/testimonial/testi-shape-2.png";
import shapeImg2 from "../../assets/img/testimonial/testi-shape-3.png";
import shapeImg3 from "../../assets/img/testimonial/testi-shape-4.png";
import { Pagination } from "swiper/modules";

const Testimonial = () => {
  // Custom testimonials data for PRD Infotech
  const testimonials = [
    {
      name: "Vikram Mehta",
      designation: "CTO, FutureTech Solutions",
      description:
        "PRD Infotech's custom ERP implementation has transformed our operations. Their team demonstrated exceptional technical expertise and understanding of our business processes.",
    },
    {
      name: "Meera Kapoor",
      designation: "Managing Director, Retail Giants",
      description:
        "We've worked with several IT companies, but PRD Infotech stands out with their commitment to quality and timeline adherence. Their CRM solution perfectly addressed our complex requirements.",
    },
    {
      name: "Arjun Singh",
      designation: "Product Manager, FinEdge",
      description:
        "The mobile application developed by PRD Infotech has been a game-changer for our field teams. Their developers showed remarkable skill in creating an intuitive yet powerful solution.",
    },
    {
      name: "Ritu Sharma",
      designation: "CEO, Innovate Digital",
      description:
        "PRD Infotech delivered our website redesign project with exceptional creativity and technical precision. The results exceeded our expectations and significantly improved our online presence.",
    },
    {
      name: "Dhruv Patel",
      designation: "Operations Head, LogiConnect",
      description:
        "The custom logistics software from PRD Infotech has streamlined our entire supply chain. Their team's responsiveness during implementation and post-launch support has been outstanding.",
    },
  ];

  const sliderOption = {
    pagination: {
      el: ".testimonial-slider-dots",
      clickable: true,
    },
    loop: true,
    spaceBetween: 30,
    slidesPerView: "2",
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <div className="testimonial__area testimonial__plr black-bg p-relative mb-100">
      <div className="testimonial__shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="testimonial__shape-2">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="testimonial__shape-3">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-7 col-xxl-9 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              sectionClass="testimonial__section-box text-center z-index pb-40 section-title-fixed-width"
              subTitleClass="section-subtitle section-white-bg"
              titleClass="section-title text-white"
              subTitle="Client Testimonial"
              Title="What Clients Say About PRD Infotech Solutions"
            />
          </div>
        </div>
        <div
          className="testimonial__slider-wrapper z-index wow animate__fadeInUp"
          data-wow-duration="1.1s"
        >
          <div className="swiper-container testimonial__active">
            <Swiper
              modules={[Pagination]}
              {...sliderOption}
              className="swiper-wrapper"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index} className="swiper-slide">
                  <SingleTestimonial
                    Name={testimonial.name}
                    Designation={testimonial.designation}
                    Description={testimonial.description}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="testimonial-slider-dots wow animate__fadeInUp"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
